import { Component, forwardRef, inject, input } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TenantService } from '@artemis-software/wr-api';
import { NbToastrService } from '@nebular/theme';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'wr-pin-input',
  templateUrl: './pin-input.component.html',
  styleUrls: ['./pin-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PinInputComponent),
      multi: true,
    },
  ],
})
export class PinInputComponent extends AbstractFormControl<string> {
  private readonly tenantService = inject(TenantService);
  private readonly nbToastrService = inject(NbToastrService);

  readonly canEdit = input(false);

  async generateNewPin() {
    this.value = await firstValueFrom(this.tenantService.generatePin());
    this.nbToastrService.success('Neuer PIN wurde generiert.', 'Erfolgreich');
  }

  async copyToClipboard() {
    if (this.value) {
      await navigator.clipboard.writeText(this.value);
      this.nbToastrService.success('PIN wurde in die Zwischenablage kopiert.', 'Erfolgreich');
    } else {
      this.nbToastrService.danger('Fehler beim Kopieren des PINs.', 'Fehler');
    }
  }
}
